
import { useMemo } from "react";
import StrategyDetail from "@/components/StrategyDetail";
import { Strategy } from "@/components/marketplace/types/marketplace-types";
import { AccountPerformanceData } from "@/components/marketplace/types/strategy-card-types";

interface StrategyDetailContainerProps {
  selectedStrategy: string | null;
  setSelectedStrategy: (strategy: string | null) => void;
  strategies: any[];
  accountPerformance: Record<string, AccountPerformanceData>;
}

const StrategyDetailContainer = ({
  selectedStrategy,
  setSelectedStrategy,
  strategies,
  accountPerformance
}: StrategyDetailContainerProps) => {
  // Find the selected strategy object
  const selectedStrategyObject = useMemo(() => {
    if (!selectedStrategy) return null;
    
    const strategy = strategies.find(s => 
      (s.name || (s as any).strategy_name) === selectedStrategy
    );
    
    // Don't show details for "Coming Soon" strategies
    if (strategy && strategy.approved === true && strategy.active === false) {
      return null;
    }
    
    return strategy;
  }, [selectedStrategy, strategies]);

  // Helper function to safely find the strategy ID
  const findStrategyId = (strategyName: string | null): string => {
    if (!strategyName) return '';
    const strategy = strategies.find(s => {
      const sName = s.name || (s as any).strategy_name;
      return sName === strategyName;
    });
    return strategy?.id || '';
  };

  return (
    <>
      {selectedStrategyObject && (
        <StrategyDetail
          isOpen={!!selectedStrategyObject}
          onClose={() => setSelectedStrategy(null)}
          strategy={selectedStrategyObject as any}
          performanceData={selectedStrategy ? accountPerformance[findStrategyId(selectedStrategy)] : undefined}
        />
      )}
    </>
  );
};

export default StrategyDetailContainer;
